// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__N3xFH","label":"Completed_label__2O193"};